import { render, staticRenderFns } from "./IconCurrencyYenSolid.vue?vue&type=template&id=3a149004"
import script from "./IconCurrencyYenSolid.vue?vue&type=script&lang=js"
export * from "./IconCurrencyYenSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports